import { trace } from 'owa-trace';
import { ContentPosition, IEditor } from 'roosterjs-editor-types';
import type { SonoraViewState } from 'owa-editor-sonora-types';
import createZeroQueryHintNode from './createZeroQueryHintNode';

// Shows the zero query hint to the user by appending it in a span of grey text right
// at the current insertion point
export default function handleZeroQueryHintInEditor(
    viewState: SonoraViewState,
    editor: IEditor | undefined,
    nodeText: string
): HTMLElement | null {
    if (editor && nodeText !== '') {
        const { isSuggesting, queryString } = viewState;
        // Check if 1) callout is open 2) no query strings
        if (isSuggesting && !queryString) {
            const node = createZeroQueryHintNode(editor, nodeText);
            trace.info('[Sonora Plugin] Adding zero query hint to editor.');
            editor.insertNode(node, {
                position: ContentPosition.SelectionStart,
                updateCursor: false,
                replaceSelection: true,
                insertOnNewLine: false,
            });
            return node;
        }
    }
    return null;
}
